import React from 'react';
import './MaintenancePage.css';

function MaintenancePage() {
    return (
        <div
            className="maintenance-page"
            role="main"
            aria-label="Site under maintenance"
            id="maintenance-page-root"
        >
            {/* Main content */}
            <div className="maintenance-content">

                {/* Logo */}
                <img
                    src="/logo (2).png"
                    alt="WallZ"
                    className="maintenance-logo"
                />

                {/* Status badge */}
                <div className="maintenance-badge" role="status">
                    <span className="maintenance-badge-line" aria-hidden="true" />
                    Back Soon
                    <span className="maintenance-badge-line" aria-hidden="true" />
                </div>

                {/* Heading */}
                <h1 className="maintenance-heading" id="maintenance-headline">
                    We're taking<br />
                    a <em>moment</em>
                </h1>

                {/* Divider */}
                <div className="maintenance-line" aria-hidden="true" />

                {/* Body */}
                <p className="maintenance-body" id="maintenance-description">
                    We're polishing things up behind the scenes.
                    The shop will be available again very soon —
                    thank you for your patience.
                </p>

                {/* Contact */}
                <p className="maintenance-contact" id="maintenance-contact">
                    Need help?{' '}
                    <a
                        href="https://wa.me/201008382951"
                        target="_blank"
                        rel="noopener noreferrer"
                        id="maintenance-whatsapp-link"
                        aria-label="Contact WallZ on WhatsApp"
                    >
                        Message us on WhatsApp
                    </a>
                </p>
            </div>

            {/* Footer */}
            <p className="maintenance-footer" aria-hidden="true">
                WallZ — Poster Shop
            </p>
        </div>
    );
}

export default MaintenancePage;
